
  import NoDataToShow from '@/components/elements/NoDataToShow';
  import JobListingFilter from '@/components/elements/JobListingFilter';
  import SendViaEmail from '@/components/SendViaEmail';
  import JobAlert from '@/components/JobAlert';
  import EventBus from '@/events/EventBus';
  import Events from '@/events/Events';
  import {convertHydraObjectToArray} from '@/helper/ArrayHelper';
  import {saveNewSearch} from '@/helper/LastSearchesHelper';
  import {
    createObjectFromQuery,
    createObjectFromUrlSearchParams,
    createUrlSearchParamsFromObject,
    createObjectFromQueryString,
  } from '@/helper/QueryHelper';

  export default {
    name: 'SectionJobListingWithFilter',
    components: {
      NoDataToShow,
      JobListingFilter,
      JobListingFilterDialog: () =>
        import('@/components/filter-dialogs/JobListingFilterDialog'),
      Pagination: () => import('@/components/Pagination'),
      JobListing: () => import('@/components/elements/JobListing'),
      SendViaEmail,
      JobAlert,
      RichText: () => import('@/components/elements/RichText'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        loading: true,
        mergedJobPostings: [],
        topJobPositions: [],
        instantTeaserPositions: [],
        instantTeaserAddition: 1,
        page: 1,
        countPages: 0,
        itemsPerPage: 16,
        jobPostingsCount: 0,
        filterParams: '',
        orderBy: {},
        newSearchArray: [],
        orderByDefault: {key: 'order_number', direction: 'desc'},
        orderByItems: [
          {
            value: {key: 'order_number', direction: 'desc'},
            text: this.$t('orderBy.order_number.desc'),
          },
          {
            value: {key: 'order_number', direction: 'asc'},
            text: this.$t('orderBy.order_number.asc'),
          },
          {
            value: {key: 'date', direction: 'desc'},
            text: this.$t('orderBy.date.desc'),
          },
          {
            value: {key: 'date', direction: 'asc'},
            text: this.$t('orderBy.date.asc'),
          },
          {
            value: {key: 'rank', direction: 'desc'},
            text: this.$t('orderBy.rank.desc'),
          },
          {
            value: {key: 'rank', direction: 'asc'},
            text: this.$t('orderBy.rank.asc'),
          },
        ],
        title: '',
      };
    },
    async fetch() {
      this.parseOrderAndPageFromQuery();
      this.generateFilterParamsFromQuery();

      await this.fetchJobPostings();
      this.prepareTitle();
    },
    head() {
      const head = {meta: []};
      const query = Object.assign({}, this.$route.query);
      const canonical_links = [];

      canonical_links.push({
        rel: 'canonical',
        hid: 'canonical',
        href:
          process.env.NUXT_ENV_BASE_URL +
          this.localePath({
            query: {page: this.page > 1 ? this.page : undefined},
          }),
      });

      if (this.page > 1) {
        query.page = this.page - 1;
        canonical_links.push({
          rel: 'prev',
          hid: 'prev',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      if (this.page < this.countPages) {
        query.page = this.page + 1;
        canonical_links.push({
          rel: 'next',
          hid: 'next',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      head.link = canonical_links;

      if (this.$route.query.user_search || this.page > 1) {
        head.meta.push({
          name: 'robots',
          content: 'noindex',
        });
        head.meta.push({
          name: 'googlebot',
          content: 'noindex',
        });
      }

      return head;
    },
    computed: {
      currentUrl() {
        const getParameters = new URLSearchParams(this.fullFilterParams);
        getParameters.delete('user_search');
        if (this.orderBy.key === 'rank') {
          if (getParameters.get('search')) {
            getParameters.set(
              'order[rank][query]',
              getParameters.get('search')
            );
            getParameters.set('order[rank][direction]', this.orderBy.direction);
          } else {
            getParameters.set(
              `order[${this.orderByDefault.key}]`,
              this.orderByDefault.direction
            );
          }
        } else {
          getParameters.set(
            `order[${this.orderBy.key}]`,
            this.orderBy.direction
          );
        }
        getParameters.set('itemsPerPage', this.itemsPerPage);
        getParameters.set('page', this.page);
        return (
          'scope=promotionbasis&' +
          decodeURI(getParameters.toString()) +
          '&isPublished=1'
        );
      },
      filterParamsObjectFromSection() {
        const filterParams = {};
        if (this.section.filterParams && this.section.filterParams.search) {
          filterParams.search = this.section.filterParams.search;
        }
        if (this.section.filterParams && this.section.filterParams.activities) {
          filterParams['activity[]'] = this.section.filterParams.activities
            .split(',')
            .map((value) => value.trim());
        }
        if (
          this.section.filterParams &&
          this.section.filterParams.latitude &&
          this.section.filterParams.longitude &&
          this.section.filterParams.distance
        ) {
          filterParams.distance = `${this.section.filterParams.latitude},${this.section.filterParams.longitude},${this.section.filterParams.distance}`;
        }
        return filterParams;
      },
      forcedFilterParams() {
        const forcedFilterParams = new URLSearchParams();
        if (this.section.filterParams && this.section.filterParams.tags) {
          this.section.filterParams.tags.split(',').forEach((value) => {
            forcedFilterParams.append('tagsOr[]', value.trim());
          });
        }
        return forcedFilterParams.toString();
      },
      filterParamsWithMyFilters() {
        const filterParamsObject = new URLSearchParams(this.filterParams);

        if (filterParamsObject.has('my_age')) {
          filterParamsObject.delete('my_age');
          if (this.$auth.user.candidateProfile.birthDate) {
            const now = new Date();
            const birthdate = new Date(
              this.$auth.user.candidateProfile.birthDate
            );
            const age = Math.floor(
              Math.abs(birthdate - now) / (1000 * 3600 * 24 * 365)
            );
            filterParamsObject.set('age', age.toString());
          }
        }

        if (filterParamsObject.has('my_bodyHeight')) {
          filterParamsObject.delete('my_bodyHeight');
          if (this.$auth.user.candidateProfile.bodyHeight) {
            filterParamsObject.set(
              'bodyHeight',
              this.$auth.user.candidateProfile.bodyHeight
            );
          }
        }

        if (filterParamsObject.has('my_gender')) {
          filterParamsObject.delete('my_gender');
          let gender;
          switch (this.$auth.user.candidateProfile.gender) {
            case 'gender.male':
              gender = 'm';
              break;
            case 'gender.female':
              gender = 'f';
              break;
          }
          if (gender) {
            filterParamsObject.set('gender', gender);
          }
        }

        if (filterParamsObject.has('my_preferredActivities')) {
          filterParamsObject.delete('my_preferredActivities');
          for (const activity_key in convertHydraObjectToArray(
            this.$auth.user.candidateProfile.preferredActivities
          )) {
            filterParamsObject.append(
              'activity[]',
              this.$auth.user.candidateProfile.preferredActivities[activity_key]
            );
          }
        }

        if (filterParamsObject.has('my_preferredIndustries')) {
          filterParamsObject.delete('my_preferredIndustries');
          for (const industry_key in convertHydraObjectToArray(
            this.$auth.user.candidateProfile.preferredIndustries
          )) {
            filterParamsObject.append(
              'industry[]',
              this.$auth.user.candidateProfile.preferredIndustries[industry_key]
            );
          }
        }

        return filterParamsObject.toString();
      },
      fullFilterParams() {
        const glue =
          this.filterParamsWithMyFilters !== '' &&
          this.forcedFilterParams !== ''
            ? '&'
            : '';
        return this.filterParamsWithMyFilters + glue + this.forcedFilterParams;
      },
    },
    watch: {
      '$route.query': function () {
        const pageBefore = this.page;
        const orderByBefore = this.orderBy;
        const filterParamsBefore = this.filterParams;

        this.parseOrderAndPageFromQuery();
        this.generateFilterParamsFromQuery();

        if (
          pageBefore !== this.page ||
          orderByBefore.key !== this.orderBy.key ||
          orderByBefore.direction !== this.orderBy.direction ||
          filterParamsBefore !== this.filterParams
        ) {
          this.fetchJobPostings();
        }
      },
      jobPostingsCount: function () {
        this.prepareTitle();
      },
    },
    created() {
      if (process.client) {
        EventBus.$on('login', this.fetchJobPostings);
        EventBus.$on('logout', this.fetchJobPostings);

        EventBus.$on('applied-on-job', this.refetchJobPosting);
        EventBus.$on('favored-job', this.refetchJobPosting);
        EventBus.$on('unfavored-job', this.refetchJobPosting);
      }
    },
    updated() {
      if (this.$device.isDesktop) {
        const filterBar = document.querySelector('#pb-filter-bar>div');
        const mainTitle = document.querySelector('#pb-joblisting-main-title');
        if (
          mainTitle &&
          filterBar &&
          mainTitle.getBoundingClientRect().height >
            filterBar.getBoundingClientRect().height + 100
        ) {
          document.getElementById('pb-inside-div').style.position = 'absolute';
          document.getElementById('pb-inside-div').style.left = '0px';
          document.getElementById('pb-inside-div').style.width = '100%';
          document.getElementById('pb-inside-div').style.padding = 'inherit';
        } else {
          document.getElementById('pb-inside-div').style.position = 'relative';
          document.getElementById('pb-inside-div').style.padding = 'initial';
        }
      }
    },
    mounted() {
      const filterBarContainer = document.querySelector('#pb-filter-bar');
      const filterBar = document.querySelector('#pb-filter-bar>div');
      let timeout;
      if (this.$device.isDesktop && filterBarContainer && filterBar) {
        this.scrollHandler = function () {
          if (timeout) clearTimeout(timeout);
          timeout = setTimeout(function () {
            const vh = document.documentElement.clientHeight;
            const boundingRect = filterBar.getBoundingClientRect();
            if (boundingRect.bottom < vh) {
              const currentTop = parseInt(filterBar.style.top, 10);
              filterBar.style.top =
                currentTop + (vh - boundingRect.bottom) + 'px';
            }
            if (boundingRect.top - vh > -vh) {
              const currentTop = parseInt(filterBar.style.top, 10);
              filterBar.style.top = currentTop - boundingRect.top + 100 + 'px';
            }
            const newTop = parseInt(filterBar.style.top, 10);
            const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
            filterBar.style.top =
              clamp(
                newTop,
                0,
                filterBarContainer.getBoundingClientRect().height -
                  boundingRect.height
              ) + 'px';
          }, 100);
        };
        document.addEventListener('scroll', this.scrollHandler);
      }
    },
    destroyed() {
      if (process.client) {
        if (this.scrollHandler) {
          document.removeEventListener('scroll', this.scrollHandler);
        }

        EventBus.$off('login', this.fetchJobPostings);
        // this breaks!??? WHY!????
        // EventBus.$off('logout', this.fetchJobPostings);
        // This works though
        EventBus.$off('logout');

        EventBus.$off('applied-on-job', this.refetchJobPosting);
        EventBus.$off('favored-job', this.refetchJobPosting);
        EventBus.$off('unfavored-job', this.refetchJobPosting);
      }
    },
    methods: {
      parseOrderAndPageFromQuery() {
        this.page = this.$route.query.page
          ? parseInt(this.$route.query.page)
          : 1;

        const foundOrder = Object.keys(this.$route.query).find((k) =>
          k.includes('order[')
        );
        if (foundOrder) {
          const order = foundOrder.match(/^order\[(.+)\]$/)[1];
          this.orderBy = {
            key: order,
            direction: this.$route.query[foundOrder],
          };
        } else {
          this.orderBy = {...this.orderByDefault};
        }
      },
      generateFilterParamsFromQuery() {
        const filterParams = this.$route.query.user_search
          ? {}
          : {...this.filterParamsObjectFromSection};

        const queryParams = createObjectFromQuery(this.$route.query);
        for (const key in queryParams) {
          if (!Object.prototype.hasOwnProperty.call(queryParams, key)) {
            continue;
          }
          if (key === 'page' || key.includes('order[')) {
            continue;
          }
          filterParams[key] = queryParams[key];
        }
        const urlSearchParams = createUrlSearchParamsFromObject(filterParams);
        urlSearchParams.sort();
        this.filterParams = urlSearchParams.toString();
      },
      async fetchJobPostings() {
        const getParameters = new URLSearchParams(this.fullFilterParams);
        getParameters.delete('user_search');
        if (this.orderBy.key === 'rank') {
          if (getParameters.get('search')) {
            getParameters.set(
              'order[rank][query]',
              getParameters.get('search')
            );
            getParameters.set('order[rank][direction]', this.orderBy.direction);
          } else {
            getParameters.set(
              `order[${this.orderByDefault.key}]`,
              this.orderByDefault.direction
            );
          }
        } else {
          getParameters.set(
            `order[${this.orderBy.key}]`,
            this.orderBy.direction
          );
        }
        getParameters.set('itemsPerPage', this.itemsPerPage);
        getParameters.set('page', this.page);

        const [
          jobPostingResponse,
          jobPostingTopJobResponse,
          jobPostingInstantTeaserResponse,
        ] = await Promise.all([
          this.$store.dispatch('api/jobPosting/getJobPostings', getParameters),
          this.$store.dispatch(
            'api/jobPosting/getTopJobPosting',
            new URLSearchParams(this.fullFilterParams)
          ),
          this.$store.dispatch(
            'api/jobPosting/getInstantTeaserJobPostings',
            new URLSearchParams(this.fullFilterParams)
          ),
        ]);
        this.jobPostingsCount = jobPostingResponse.totalItems;
        this.countPages = Math.ceil(
          jobPostingResponse.totalItems / this.itemsPerPage
        );

        this.mergedJobPostings = this.mergeJobPostings(
          jobPostingResponse.data,
          jobPostingTopJobResponse,
          jobPostingInstantTeaserResponse
        );
        this.loading = false;
        this.emitJobListingView();
      },
      mergeJobPostings(jobPostings, topJobPosting, instantTeaserJobPostings) {
        this.instantTeaserPositions = [];
        this.topJobPositions = [];

        const filteredJobPostings = [];

        if (topJobPosting) {
          filteredJobPostings.push(topJobPosting);
          this.topJobPositions.push(filteredJobPostings.length);
        }

        for (const jobPosting of jobPostings) {
          if (
            !this.isTopJobPosting(jobPosting, topJobPosting) &&
            !this.isInstantTeaserJobPosting(
              jobPosting,
              instantTeaserJobPostings
            )
          ) {
            filteredJobPostings.push(jobPosting);
          }
        }

        // short exit if no instantTeaserJobPostings
        if (instantTeaserJobPostings.length === 0) {
          return filteredJobPostings;
        }

        const numInstantTeasers =
          instantTeaserJobPostings.length + this.instantTeaserAddition;
        const cutOff = filteredJobPostings.length % numInstantTeasers;
        const jobsInterval =
          (filteredJobPostings.length - cutOff) / numInstantTeasers;

        let mergedJobs = [];
        for (let i = 0; i < numInstantTeasers; i++) {
          mergedJobs = mergedJobs.concat(
            filteredJobPostings.splice(0, jobsInterval)
          );
          this.addInstantTeaser(
            mergedJobs,
            i,
            instantTeaserJobPostings,
            topJobPosting
          );
        }
        mergedJobs = mergedJobs.concat(filteredJobPostings);
        return mergedJobs;
      },
      isTopJobPosting(jobPosting, topJobPosting) {
        return topJobPosting && jobPosting.id === topJobPosting.id;
      },
      isInstantTeaserJobPosting(jobPosting, instantTeaserJobPostings) {
        for (const item of instantTeaserJobPostings) {
          if (item.id === jobPosting.id) {
            return true;
          }
        }
        return false;
      },
      addInstantTeaser(
        mergedJobs,
        instantTeaserIndex,
        instantTeaserJobPostings,
        topJobPosting
      ) {
        if (
          instantTeaserJobPostings[instantTeaserIndex] &&
          !this.isTopJobPosting(
            instantTeaserJobPostings[instantTeaserIndex],
            topJobPosting
          )
        ) {
          mergedJobs.push(instantTeaserJobPostings[instantTeaserIndex]);
          this.instantTeaserPositions.push(mergedJobs.length);
        }
      },
      pushRouterAndFetchJobPostings() {
        this.pushRouter();
        this.fetchJobPostings();
      },
      setFilterParamsAndResetOrderAndPage(params) {
        this.page = 1;
        this.orderBy = {...this.orderByDefault};
        params.set('user_search', '1');
        this.setFilterParams(params, true);

        this.$emitWithClientData(Events.JobsSearched, {
          filterParams: createObjectFromUrlSearchParams(params),
        });
      },
      resetFilterParams() {
        this.page = 1;
        this.orderBy = {...this.orderByDefault};
        const params = createUrlSearchParamsFromObject({
          ...this.filterParamsObjectFromSection,
        });
        params.set('user_search', '1');
        this.setFilterParams(params, true);
      },
      setFilterParams(params, force) {
        params.sort();
        if (!force && params.toString() === this.filterParams) {
          return;
        }

        this.filterParams = params.toString();
        this.pushRouterAndFetchJobPostings();
      },
      async pushRouter() {
        const filterValues = createObjectFromQueryString(this.filterParams);
        if (
          filterValues.search ||
          filterValues.whereInput ||
          filterValues['activity[]'] ||
          filterValues['industry[]'] ||
          filterValues['employmentTypesOr[]']
        ) {
          const url =
            this.localePath({}) +
            `?${this.filterParams}` +
            `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
            `&page=1`;
          const newSearch = {
            page: this.$route.path,
            url: url,
            what: filterValues.search || '',
            where: filterValues.whereInput || '',
            activities: filterValues['activity[]'] || [],
            branches: filterValues['industry[]'] || [],
            employmentTypesOr: filterValues['employmentTypesOr[]'] || [],
          };
          this.newSearchArray = saveNewSearch(
            newSearch,
            await this.$localforage.getItem('SavedSearches')
          );
          await this.$localforage.setItem('SavedSearches', this.newSearchArray);
        }
        this.$router.push(
          this.localePath({}) +
            `?${this.filterParams}` +
            `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
            `&page=${this.page}`
        );
      },
      prepareTitle() {
        this.title = this.section.title.replace(
          '%num_job_postings',
          this.jobPostingsCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        );
      },
      emitJobListingView() {
        const items = this.mergedJobPostings.map((item, key) => {
          const position = key + 1;
          return {
            id: item.id,
            topJob: this.topJobPositions.includes(position),
            instantTeaser: this.instantTeaserPositions.includes(position),
            position,
          };
        });

        this.$emitWithClientData(Events.JobListingViewed, {
          itemsPerPage: this.itemsPerPage,
          items,
          page: this.page,
        });
      },
      refetchJobPosting(jobPostingId) {
        const jobPostingPosition = this.mergedJobPostings.findIndex(
          (item) => item.id === jobPostingId
        );
        if (jobPostingPosition > -1) {
          this.$store
            .dispatch('api/jobPosting/getJobPosting', jobPostingId)
            .then((jobPosting) => {
              this.mergedJobPostings = Array.from(this.mergedJobPostings);
              this.mergedJobPostings[jobPostingPosition] = jobPosting;
            });
        }
      },
    },
  };
